import { createElement } from "react";
import React from "react";
import * as react from "react";
import { TaskMsg, useFeliz_UseElmish_React__React_useTaskDispatch_Static } from "../hooks/UseTaskDispatch.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { PromiseBuilder__For_1565554B, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { newGuid } from "../fable_modules/fable-library-js.4.24.0/Guid.js";
import { Systems_SystemOwnerData, Systems_AssignStatus, Systems_AssignProductionUnit, Systems_UpdateSystem, Systems_CreateSystem } from "../ServerTypes.fs.js";
import { removeSystemOwner, setSystemOwner, assignStatus, assignProductionUnit, update as update_1, create as create_2 } from "../Api/Systems.fs.js";
import { Modal_ModalWithBreakdown } from "./Modal.fs.js";
import { safeHash, equals, stringHash, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { empty, tryHead, length, choose, singleton, cons, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { MaturitySelector_MaturitySelector, UserSelector_UserSelector, StatusSelector_StatusSelector } from "../components/Components.fs.js";
import { defaultArg, map, unwrap } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { List_groupBy } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { DomainEntity__get_Name, DomainEntity__get_Id, Entity__get_Id } from "../ClientTypes.fs.js";
import { DomainEntitySelector, EntitySelector } from "../components/EntitySelector.fs.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { EPM_Domain_Events_Maturity__Maturity_ToProperString } from "../Prelude.fs.js";
import { DomainEntities } from "../DomainEvents.fs.js";

export function Create(createInputProps) {
    let xs_12, elms_1, elms, elms_3, elms_2, elms_4;
    const close = createInputProps.close;
    const projectId = createInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState("");
    const name = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const detail = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const statusOpt = patternInput_3[0];
    let create_1;
    const dependencies_1 = [name, detail, statusOpt];
    create_1 = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (isNullOrWhiteSpace(name)) {
                return Promise.resolve();
            }
            else {
                const taskId = newGuid();
                taskDispatch(new TaskMsg(0, [taskId, "Create"]));
                const create = new Systems_CreateSystem(name, detail, statusOpt);
                taskDispatch(new TaskMsg(2, [taskId]));
                return create_2(projectId, create).then((_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId, undefined]));
                        return Promise.resolve();
                    }
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_12 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_3 = ofArray([createElement("label", {
            className: "label",
            children: "Detail",
        }), (elms_2 = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev_1) => {
            patternInput_2[1](ev_1.target.value);
        }], ["defaultValue", detail]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_3)),
        })), (elms_4 = ofArray([createElement("label", {
            className: "label",
            children: "Status",
        }), createElement(StatusSelector_StatusSelector, {
            value: unwrap(statusOpt),
            required: true,
            onChange: patternInput_3[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_4)),
        }))], react.createElement(react.Fragment, {}, ...xs_12)),
        submit: create_1,
        submitText: "Create",
        tasks: patternInput[0],
        title: "Create",
    });
}

export function Update(updateInputProps) {
    let xs_10, elms_1, elms, elms_3, elms_2;
    const close = updateInputProps.close;
    const sys = updateInputProps.sys;
    const projectId = updateInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(sys.Name);
    const name = patternInput_1[0];
    const patternInput_2 = reactApi.useState(sys.Detail);
    const detail = patternInput_2[0];
    let updates;
    const dependencies_1 = [name, detail];
    updates = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (isNullOrWhiteSpace(name)) {
                return Promise.resolve();
            }
            else {
                const taskId = newGuid();
                taskDispatch(new TaskMsg(0, [taskId, `Update ${name}`]));
                const update = new Systems_UpdateSystem(name, detail);
                taskDispatch(new TaskMsg(2, [taskId]));
                return update_1(projectId, sys.Id, update).then((_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId, undefined]));
                        return Promise.resolve();
                    }
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_10 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_3 = ofArray([createElement("label", {
            className: "label",
            children: "Detail",
        }), (elms_2 = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev_1) => {
            patternInput_2[1](ev_1.target.value);
        }], ["defaultValue", detail]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_3)),
        }))], react.createElement(react.Fragment, {}, ...xs_10)),
        submit: updates,
        submitText: "Update",
        tasks: patternInput[0],
        title: "Update",
    });
}

export function AssignProductionUnit(assignProductionUnitInputProps) {
    let elms;
    const close = assignProductionUnitInputProps.close;
    const systems = assignProductionUnitInputProps.systems;
    const projectId = assignProductionUnitInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const productionUnitOpt = patternInput_1[0];
    let initialProductionUnit;
    const dependencies_1 = [systems];
    initialProductionUnit = reactApi.useMemo(() => {
        const productionUnitIds = choose((m) => m.ProductionUnitId, systems);
        if (length(List_groupBy((x) => x, productionUnitIds, {
            Equals: (x_1, y) => (x_1 === y),
            GetHashCode: stringHash,
        })) > 1) {
            return undefined;
        }
        else {
            return tryHead(productionUnitIds);
        }
    }, dependencies_1);
    let assigns;
    const dependencies_1_1 = [productionUnitOpt];
    assigns = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (productionUnitOpt == null) {
                return Promise.resolve();
            }
            else {
                const move = new Systems_AssignProductionUnit(Entity__get_Id(productionUnitOpt));
                return PromiseBuilder__For_1565554B(promise, systems, (_arg) => {
                    const sys = _arg;
                    taskDispatch(new TaskMsg(0, [sys.Id, `Assign ${sys.Name} To Production Unit : ${sys.Name}`]));
                    taskDispatch(new TaskMsg(2, [sys.Id]));
                    return assignProductionUnit(projectId, sys.Id, move).then((_arg_1) => {
                        const result = _arg_1;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [sys.Id, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [sys.Id, undefined]));
                            return Promise.resolve();
                        }
                    });
                });
            }
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms = ofArray([createElement("label", {
            className: "label",
            children: "Production Unit",
        }), createElement(EntitySelector, {
            projectId: projectId,
            entityType: "productionUnit",
            initialEntity: unwrap(initialProductionUnit),
            onSelectedEntityChange: patternInput_1[1],
            isSmall: false,
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })),
        submit: assigns,
        submitText: "Assign",
        tasks: patternInput[0],
        title: "Assign Production Unit",
    });
}

export function AssignStatus(assignStatusInputProps) {
    let elms;
    const close = assignStatusInputProps.close;
    const systems = assignStatusInputProps.systems;
    const projectId = assignStatusInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const statusOpt = patternInput_1[0];
    let initialStatus;
    const dependencies_1 = [systems];
    initialStatus = reactApi.useMemo(() => {
        const statuses = choose((m) => m.Status, systems);
        if (length(List_groupBy((x) => x, statuses, {
            Equals: equals,
            GetHashCode: safeHash,
        })) > 1) {
            return undefined;
        }
        else {
            return tryHead(statuses);
        }
    }, dependencies_1);
    let assigns;
    const dependencies_1_1 = [statusOpt];
    assigns = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (statusOpt == null) {
                return Promise.resolve();
            }
            else {
                const status = statusOpt;
                const move = new Systems_AssignStatus(status);
                return PromiseBuilder__For_1565554B(promise, systems, (_arg) => {
                    const sys = _arg;
                    taskDispatch(new TaskMsg(0, [sys.Id, `Assign ${sys.Name} To Status : ${toString(status)}`]));
                    taskDispatch(new TaskMsg(2, [sys.Id]));
                    return assignStatus(projectId, sys.Id, move).then((_arg_1) => {
                        const result = _arg_1;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [sys.Id, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [sys.Id, undefined]));
                            return Promise.resolve();
                        }
                    });
                });
            }
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms = ofArray([createElement("label", {
            className: "label",
            children: "Status",
        }), createElement(StatusSelector_StatusSelector, {
            value: unwrap(initialStatus),
            required: true,
            onChange: patternInput_1[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })),
        submit: assigns,
        submitText: "Assign",
        tasks: patternInput[0],
        title: "Assign Status",
    });
}

export function SetSystemOwner(setSystemOwnerInputProps) {
    let xs_6, elms, elms_1, elms_2;
    const close = setSystemOwnerInputProps.close;
    const systems = setSystemOwnerInputProps.systems;
    const projectId = setSystemOwnerInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const maturityOpt = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const disciplineOpt = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const userOpt = patternInput_3[0];
    let setOwner;
    const dependencies_1 = [maturityOpt, disciplineOpt, userOpt];
    setOwner = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (userOpt == null) {
                return Promise.resolve();
            }
            else {
                const user = userOpt;
                const move = new Systems_SystemOwnerData(user.Id, maturityOpt, map(DomainEntity__get_Id, disciplineOpt));
                const maturity = defaultArg(map(EPM_Domain_Events_Maturity__Maturity_ToProperString, maturityOpt), "Overall");
                const discipline = defaultArg(map(DomainEntity__get_Name, disciplineOpt), "");
                return PromiseBuilder__For_1565554B(promise, systems, (_arg) => {
                    const sys = _arg;
                    taskDispatch(new TaskMsg(0, [sys.Id, `Set ${user.Name} as ${maturity} ${discipline} Owner of System : ${sys.Name}`]));
                    taskDispatch(new TaskMsg(2, [sys.Id]));
                    return setSystemOwner(projectId, sys.Id, move).then((_arg_1) => {
                        const result = _arg_1;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [sys.Id, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [sys.Id, undefined]));
                            return Promise.resolve();
                        }
                    });
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_6 = [(elms = ofArray([createElement("label", {
            className: "label",
            children: "User",
        }), createElement(UserSelector_UserSelector, {
            projectId: projectId,
            onSelectedUserChange: patternInput_3[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })), (elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Maturity",
        }), createElement(MaturitySelector_MaturitySelector, {
            required: false,
            onChange: patternInput_1[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_2 = ofArray([createElement("label", {
            className: "label",
            children: "Discipline",
        }), createElement(DomainEntitySelector, {
            projectId: projectId,
            entityType: new DomainEntities(4, []),
            onSelectedEntityChange: patternInput_2[1],
            filters: empty(),
            isSmall: false,
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))], react.createElement(react.Fragment, {}, ...xs_6)),
        submit: setOwner,
        submitText: "Set",
        tasks: patternInput[0],
        title: "Set Owner",
    });
}

export function RemoveSystemOwner(removeSystemOwnerInputProps) {
    let xs_6, elms, elms_1, elms_2;
    const close = removeSystemOwnerInputProps.close;
    const systems = removeSystemOwnerInputProps.systems;
    const projectId = removeSystemOwnerInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const maturityOpt = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const disciplineOpt = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const userOpt = patternInput_3[0];
    let removeOwner;
    const dependencies_1 = [maturityOpt, disciplineOpt, userOpt];
    removeOwner = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (userOpt == null) {
                return Promise.resolve();
            }
            else {
                const user = userOpt;
                const move = new Systems_SystemOwnerData(user.Id, maturityOpt, map(DomainEntity__get_Id, disciplineOpt));
                const maturity = defaultArg(map(EPM_Domain_Events_Maturity__Maturity_ToProperString, maturityOpt), "Overall");
                const discipline = defaultArg(map(DomainEntity__get_Name, disciplineOpt), "");
                return PromiseBuilder__For_1565554B(promise, systems, (_arg) => {
                    const sys = _arg;
                    taskDispatch(new TaskMsg(0, [sys.Id, `Set ${user.Name} as ${maturity} ${discipline} Owner of System : ${sys.Name}`]));
                    taskDispatch(new TaskMsg(2, [sys.Id]));
                    return removeSystemOwner(projectId, sys.Id, move).then((_arg_1) => {
                        const result = _arg_1;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [sys.Id, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [sys.Id, undefined]));
                            return Promise.resolve();
                        }
                    });
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_6 = [(elms = ofArray([createElement("label", {
            className: "label",
            children: "User",
        }), createElement(UserSelector_UserSelector, {
            projectId: projectId,
            onSelectedUserChange: patternInput_3[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })), (elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Maturity",
        }), createElement(MaturitySelector_MaturitySelector, {
            required: false,
            onChange: patternInput_1[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_2 = ofArray([createElement("label", {
            className: "label",
            children: "Discipline",
        }), createElement(DomainEntitySelector, {
            projectId: projectId,
            entityType: new DomainEntities(4, []),
            onSelectedEntityChange: patternInput_2[1],
            filters: empty(),
            isSmall: false,
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))], react.createElement(react.Fragment, {}, ...xs_6)),
        submit: removeOwner,
        submitText: "Remove",
        tasks: patternInput[0],
        title: "Remove Owner",
    });
}

